import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=ab84526e&scoped=true&"
import script from "./Portfolio.vue?vue&type=script&lang=js&"
export * from "./Portfolio.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=ab84526e&prod&scoped=true&lang=css&"
import style1 from "./Portfolio.vue?vue&type=style&index=1&id=ab84526e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab84526e",
  null
  
)

export default component.exports